module.exports = __webpack_public_path__ + "img/light-bulb.329f16ab.svg";